import { Component, OnInit, Output, EventEmitter, Optional } from '@angular/core';

// Services
import { AircraftsService } from '../../../services/aircrafts.service';

export interface NewCustomerAircraftDialogData {
    gropupId: number;
    customerId: number;
    aircraftId: number;
    tailNumber: string;
    size: number;
    basedPageLocation: string;
    networkCode: string;
    addedFrom: number;
    selectedAircraft: any;
    oid?: number;
    groupId?: number;
}

@Component({
    selector: 'app-customer-aircrafts-dialog-new-aircraft',
    styleUrls: ['./customer-aircrafts-dialog-new-aircraft.component.scss'],
    templateUrl: './customer-aircrafts-dialog-new-aircraft.component.html',
})
export class CustomerAircraftsDialogNewAircraftComponent implements OnInit {
    // Public Members
    public aircraftSizes: Array<any>;
    public aircraftTypes: Array<any>;

    // Data property - will be set by dialog wrapper
    private _data: NewCustomerAircraftDialogData;
    get data(): NewCustomerAircraftDialogData {
        return this._data;
    }
    set data(value: NewCustomerAircraftDialogData) {
        this._data = value;
    }

    // EventEmitters for dialog communication
    @Output() addAircraft = new EventEmitter<NewCustomerAircraftDialogData>();
    @Output() cancelDialog = new EventEmitter<void>();

    constructor(
        @Optional() private aircraftsService: AircraftsService
    ) {}

    ngOnInit() {
        if (this.aircraftsService) {
            this.aircraftsService
                .getAll()
                .subscribe((data: any) => (this.aircraftTypes = data));
            this.aircraftsService
                .getAircraftSizes()
                .subscribe((data: any) => (this.aircraftSizes = data));
        }
    }

    // Public Methods
    public onAircraftTypeChanged(selectedAircraft) {
        if (this.data) {
            this.data.selectedAircraft = selectedAircraft;
            this.data.aircraftId = this.data.selectedAircraft.aircraftId;
            this.data.size = this.data.selectedAircraft.size;
        }
    }

    public displayAircraft(aircraft) {
        return aircraft ? `${aircraft.make} ${aircraft.model}` : aircraft;
    }

    public onCancelClick(): void {
        this.cancelDialog.emit();
    }

    public onAddAircraftClick(): void {
        if (this.data && this.data.tailNumber && this.data.selectedAircraft) {
            this.addAircraft.emit(this.data);
        }
    }
}
